import classNames from 'classnames';
import { get } from 'lodash';
import { Chips, ChipsProps } from 'primereact/chips';
import React from 'react';
import styled from 'styled-components';

const StyledChips = styled(Chips)`
  &.white {
    ul {
      background-color: var(--white-main);
    }

    li:not(.p-chips-input-token) {
      background-color: var(--beige-main) !important;
    }
  }
`;

export type FormikChipsProps = {
  field: {
    name: string;
    value: Array<any>;
    onChange: () => void;
    onBlur: () => void;
  };
  form: { touched: Record<string, any>; errors: Record<string, any> };
  label?: string;
};

export const FormikChips: React.FC<FormikChipsProps & ChipsProps> = ({
  field,
  form,
  label,
  required,
  className,
  ...rest
}) => {
  const fieldError = get(form.errors, field.name);
  const fieldTouched = get(form.touched, field.name);

  return (
    <>
      <label
        htmlFor={field.name}
        className={classNames({
          'p-error': fieldTouched && !!fieldError,
        })}
      >
        {label}
        {required ? <span className="red"> *</span> : ''}
      </label>
      <StyledChips
        {...field}
        addOnBlur
        className={className}
        value={field.value ?? undefined}
        {...rest}
      />
      {fieldTouched && !!fieldError ? (
        <small className="p-error">{fieldError}</small>
      ) : null}
    </>
  );
};
